//export const backendRoot = "https://localhost:7299/"
//export const backendRoot = "https://192.168.100.4:8510/"
//export const backendRoot = "https://109.198.28.153:8510/"
//export const backendRoot = "https://194.106.180.42:7299/"
export const backendRoot = "https://backend.5mzabava.com/"